Hop.defineModule('brief-entrust-my-research-tooltip', (root) => {
    let updateWebPrefs;
    let shouldMarkAsDisplayed = true;

    const overriddenModalIds = ['slideShowModal', 'welcomeModal'];

    function markAsDisplayed() {
        fetch('/api/webpref/brief-entrust-my-research-mark-as-displayed', {
            headers: new Headers(),
            method: 'POST',
        });
    }

    function init() {
        const dontDisplayModal = overriddenModalIds.some((modalId) => document.getElementById(modalId));
        if (dontDisplayModal) {
            shouldMarkAsDisplayed = false;
            return root.parentNode.classList.remove('active-popover');
        }
        root.removeAttribute('hidden');
        updateWebPrefs = setTimeout(() => {
            markAsDisplayed();
        }, 5000);
    }

    init();

    return function destroy() {
        clearTimeout(updateWebPrefs);
        if (shouldMarkAsDisplayed) {
            markAsDisplayed();
        }
    };
});
